import { apiRequest } from "../../api/apiClient";
import { settingsService } from "./settings.service";

export const notificationService = {
  /**
   * Check whether email notifications should be sent.
   * Returns true only if both emailNotifications AND workflowReminders settings are "true".
   */
  shouldSendEmailNotification: async (): Promise<boolean> => {
    try {
      const [emailSetting, reminderSetting] = await Promise.all([
        settingsService.getSettingByKey("emailNotifications"),
        settingsService.getSettingByKey("workflowReminders"),
      ]);
      return (
        emailSetting?.value === "true" && reminderSetting?.value === "true"
      );
    } catch {
      return false;
    }
  },

  /**
   * Send an email notification for a workflow record via POST /Notifications/send-email-notification.
   * Silently skips if either emailNotifications or workflowReminders setting is disabled.
   */
  sendEmailNotification: async (
    workflowId: number,
    recordId: number,
  ): Promise<void> => {
    const should = await notificationService.shouldSendEmailNotification();
    if (!should) return;

    await apiRequest("/Notifications/send-email-notification", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ workflowId, recordId }),
    });
  },
};
